export default __webpack_public_path__ + "static/media/israel.a24f7906.png";